import React from "react";

const LandDetailsSkeleton: React.FC = () => {
  return (
    <div className="pt-[140px] px-[6%] pb-12">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Content section */}
        <div className="lg:w-1/2 lg:order-1 order-2">
          {/* Title skeleton */}
          <div className="h-9 w-3/4 bg-gray-200 rounded animate-pulse mb-4"></div>

          {/* Price skeleton */}
          <div className="flex items-center gap-4 mb-6">
            <div className="h-7 w-36 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Lot info skeleton */}
          <div className="flex flex-wrap gap-4 mb-6">
            <div className="border px-4 py-2 rounded-md w-32">
              <div className="h-4 w-20 bg-gray-200 rounded animate-pulse mb-1"></div>
              <div className="h-5 w-16 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="border px-4 py-2 rounded-md w-32">
              <div className="h-4 w-20 bg-gray-200 rounded animate-pulse mb-1"></div>
              <div className="h-5 w-24 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>

          {/* Description skeleton */}
          <div className="mb-8">
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Details grid skeleton */}
          <div className="grid grid-cols-2 gap-4 mb-8">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="border p-4">
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse mb-1"></div>
                <div className="h-5 w-24 bg-gray-200 rounded animate-pulse"></div>
              </div>
            ))}
          </div>

          {/* Button skeleton */}
          <div className="h-12 w-40 bg-gray-200 rounded animate-pulse"></div>
        </div>

        {/* Image section */}
        <div className="lg:w-1/2 lg:order-2 order-1 mb-6 lg:mb-0 lg:sticky lg:top-[120px] lg:self-start">
          {/* Main image skeleton with fixed height */}
          <div className="relative w-full h-[500px] bg-gray-200 rounded animate-pulse"></div>

          {/* Thumbnail skeletons with hidden scrollbar */}
          <div
            className="flex mt-4 gap-2 overflow-x-auto hide-scrollbar"
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {[...Array(4)].map((_, index) => (
              <div
                key={index}
                className="w-[100px] h-[100px] flex-shrink-0 bg-gray-200 rounded animate-pulse"
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandDetailsSkeleton;
